import React from 'react';
import PropTypes from 'prop-types';
import FormattedAddress from '../../FormattedAddress';
import Maps from '../../../../commonComponents/maps/Maps';
import translate from '../../../../commonComponents/translate';
import OrderProp from '../../propTypes/orderProp';

function MondialRelayWrapper(props) {
  const { t, order } = props;

  const showMondialRelay =
    order.shippingPickupType === 'mondial_relay' && order.shippingPickupAddress;

  if (!showMondialRelay) {
    return null;
  }

  return (
    <div className="pickup-location-order">
      <h5>{t('shop.cart.pickupAddress')}</h5>
      <FormattedAddress
        address={order.shippingPickupAddress}
        showOptionalFields
        nameContainer="m-invoice__text"
        addressContainer="m-invoice__text"
      />
      <div className="maps-container">
        <Maps
          address={order.shippingPickupAddress}
          zoom={17}
          size={{ width: 250, height: 200 }}
        />
      </div>
    </div>
  );
}

MondialRelayWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
};

export default translate(MondialRelayWrapper);
